import Control from 'ol/control/Control';
import { Popover, Modal } from 'bootstrap';
import VectorLayer from 'ol/layer/Vector';

import { dictLayerNames, getAvailablelayers } from './layers.js';
import {
  toggleLayerVisibilityByName,
  setLayerOpacityyName,
  getLayerOpacityByName,
  getLayerByName,
  setZIndexs,
  addLayerByName,
  hideLabels,
  showLabels,
  getLayersNames,
  addLayerPoint,
  addLayerPoints,
  createMarkerPickerTool,
} from './maptoolkit.js';

import { removeExtension, createChkIndexes } from './utils.js';

import { iconsSVG } from './icons-svg.js';
import LayerGroup from 'ol/layer/Group.js';

function createButton(params) {
  let { id, classes, clickEvent, innerHTML, attributes, tooltip } = params;
  let button = document.createElement('button');
  button.type = 'button';
  button.className = classes;
  if (id) {
    button.id = id;
  }
  if (innerHTML) {
    button.innerHTML = innerHTML;
  }
  if (attributes) {
    Object.entries(attributes).forEach((entry) => {
      let [key, value] = entry;
      button.setAttribute(key, value);
    });
  }
  if (clickEvent) {
    button.addEventListener('click', function (event) {
      clickEvent.params.event = this;
      clickEvent.method(clickEvent.params);
    });
  }
  // if (tooltip) {
  //   addToolTip(button, tooltip, 'top');
  // }

  return button;
}

function createDialog(title, map) {
  let container, closeBtn, divTitle, panelHeading, divLayers;

  divTitle = document.createElement('div');
  divTitle.className = 'px-3 mb-3';
  divTitle.innerHTML = title;

  panelHeading = document.createElement('div');
  panelHeading.className = 'oim-panel-heading';

  container = document.createElement('div');
  container.className = 'oim-manage-layers oim-fade-in';
  container.style.maxHeight = getHeightPixels(map.getTarget(), 0.6);
  container.appendChild(panelHeading);

  closeBtn = createButton({
    classes: 'btn-close btn-sm btn-xs float-end oim-panel-btn-close',
    clickEvent: {
      method: function (params) {
        //container.style.display = 'none';
        container.classList.remove('show');
        deleteMapPicker(map);
      },
      params: {},
    },
  });

  divLayers = document.createElement('div');

  divTitle.appendChild(closeBtn);
  panelHeading.appendChild(divTitle);
  container.appendChild(divLayers);

  return { container, divLayers };
}

function createListForManage(map) {
  const olLayers = map.getLayers().getArray();

  let layerNames = getLayersNames(map);

  let list = document.createElement('ul');
  list.id = 'oim-list-layers-' + map.getTarget();
  list.classList = 'list-group oim-list-layers mx-2 mb-3';
  let eyeOpen = `<i style="color:blue;">${iconsSVG.eye}</i>`;
  let eyeClosed = `<i style="color:blue;">${iconsSVG.eyeSlash}</i>`;

  for (let i = 0; i < layerNames.length; i++) {
    let layerName = layerNames[i][0];
    let layer = getLayerByName(layerName, map);
    let liId = `oim-li-${layerName}-${map.getTarget()}`;

    let listItem = createListItem(liId, layerName);

    // let eyeIcon = layer.getVisible() ? eyeOpen + ' Hide' : eyeClosed + ' Show';
    let eyeIcon = layer.getVisible() ? eyeOpen : eyeClosed;
    let popoverOpacity;
    let btnToggleLabels;
    let legendElement;

    let hasDeleteBtn = layer.get('hasDeleteBtn');
    let hasLabels = layer.get('hasLabels') && (layer instanceof VectorLayer || layer instanceof LayerGroup);
    let legend = layer.get('legend');

    let btnDelete = createButton({
      classes: 'btn btn-light rounded-pill btn-sm p-0 oim-btn-add-layer ms-1',
      clickEvent: {
        method: function (params) {
          if (layer) {
            map.removeLayer(layer);
            var element = document.getElementById(liId);
            element.remove();
          }
        },
        params: {},
      },
      innerHTML: `<i style="color:red;">${iconsSVG.trash}</i>`,
      tooltip: 'Delete Layer',
    });

    let btnToggleDisplay = createButton({
      classes: 'btn btn-light rounded-pill btn-sm p-0 oim-btn-add-layer ms-1',
      clickEvent: {
        method: function (params) {
          if (layer) {
            let visible = !layer.getVisible();
            layer.setVisible(visible);
            // eyeIcon = visible ? eyeOpen + ' Hide' : eyeClosed + ' Show';
            eyeIcon = visible ? eyeOpen : eyeClosed;
            btnToggleDisplay.innerHTML = eyeIcon;
          }
        },
        params: {},
      },
      innerHTML: eyeIcon,
      tooltip: 'Toggle Display',
    });

    let btnOpacity = createButton({
      classes: 'btn btn-light rounded-pill btn-sm p-0 oim-btn-add-layer ms-1',
      clickEvent: {
        method: function (params) {
          if (layer) {
            let opacity = getLayerOpacityByName(layerName, map);
            popoverOpacity.slider.value = 100 * opacity;
            popoverOpacity.popover.toggle();
          }
        },
        params: {},
      },
      innerHTML: `<i>${iconsSVG.sun}</i>`,
      attributes: { 'data-layerName': layerName },
    });

    let btnLegend = createButton({
      classes: 'btn btn-light rounded-pill btn-sm p-0 oim-btn-add-layer ms-1',
      clickEvent: {
        method: function (params) {
          if (layer) {
            legendElement.toggle();
          }
        },
        params: {},
      },
      innerHTML: `<i>${iconsSVG.legend}</i>`,
      attributes: { 'data-layerName': layerName },
    });

    popoverOpacity = createPopover(btnOpacity, map);
    if (legend) {
      legendElement = createPopoverLegend(btnLegend, legend, listItem);
    }

    btnToggleLabels = createButton({
      classes: 'btn btn-light rounded-pill btn-sm p-0 oim-btn-add-layer ms-1',
      clickEvent: {
        method: function (params) {
          if (layer) {
            let index = olLayers.findIndex((layer) => layer.get('name') === layerName);
            if (index !== -1) {
              if (
                layer instanceof LayerGroup &&
                (layerName == 'IDWM (Group Web Server)' || layerName == 'IDWM (Group)')
              ) {
                //need to find the ctry layer in the group
                var layers = layer.getLayers().getArray();
                var IDWMctryLayer;

                for (var i = 0; i < layers.length; i++) {
                  if (layers[i].get('name') === 'IDWM (JSON)') {
                    IDWMctryLayer = layers[i];
                    break;
                  }
                }
                ToggleLabels(IDWMctryLayer);
              }
              // } else if (layer instanceof ImageLayer && layerName == 'IDWM (Image)') {
              //   ToggleLabels(layer);
              // }
              else {
                ToggleLabels(layer);
              }
            }
          }
        },
        params: {},
      },
      innerHTML: `<i>${iconsSVG.tag}</i>`,
      tooltip: 'Toggle Labels',
    });
    let btns = [];
    if (hasLabels) {
      btns.push({ btn: btnToggleLabels, disabled: !hasLabels });
    }
    if (legend) {
      btns.push({ btn: btnLegend, disabled: legend ? false : true });
    }
    if (hasDeleteBtn) {
      btns.push({ btn: btnDelete, disabled: hasDeleteBtn ? false : true });
    }

    // let btns = [
    //   { btn: btnToggleLabels, disabled: !hasLabels },
    //   { btn: btnLegend, disabled: legend ? false : true },
    //   { btn: btnDelete, disabled: hasDeleteBtn ? false : true },
    // ];

    let btnContainer = document.createElement('div');
    let dropDown = createDropDownMenu(btns);
    btnContainer.appendChild(btnToggleDisplay);
    btnContainer.appendChild(btnOpacity);
    btnContainer.appendChild(dropDown);

    listItem.appendChild(btnContainer);
    list.appendChild(listItem);
  }
  makeListDraggable(list, map);
  return list;
}

function updatePosition(sourceElement, destinationElement) {
  if (destinationElement.tip) {
    const sourceRect = sourceElement.getBoundingClientRect();
    const sourceTop = sourceRect.top;
    const sourceLeft = sourceRect.left;
    destinationElement.tip.style.setProperty('position', 'absolute', 'important');
    destinationElement.tip.style.setProperty('top', `${sourceTop}px`, 'important');
    destinationElement.tip.style.setProperty('left', `${sourceLeft}px`, 'important');
  }
}

function createListItem(liId, layerName) {
  let listItem = document.createElement('li');
  listItem.classList = 'list-group-item d-flex justify-content-between align-items-center px-2 py-1';
  listItem.id = liId;
  listItem.dataset.layer = layerName;
  listItem.setAttribute('draggable', 'true');
  let span = document.createElement('span');
  span.classList = 'oim-my-handle';
  span.innerHTML = `<i>${iconsSVG.move}</i> ${layerName}`;
  listItem.appendChild(span);
  return listItem;
}

function ToggleLabels(layer) {
  let doShowlabels = layer.get('labels');
  if (doShowlabels == null || doShowlabels == undefined) {
    doShowlabels = true;
  }

  if (doShowlabels) {
    hideLabels(layer);
  } else {
    showLabels(layer);
    // layer.setStyle(layer.get('styleOrigin'));
  }
  // layer.changed();
  layer.set('labels', !doShowlabels);
}

function deletePopovers() {
  document.querySelectorAll('.popover').forEach(function (popover) {
    popover.parentNode.removeChild(popover);
  });
}

function createListForAdd(map, isGeoServerAvailable, isProd) {
  const olLayers = map.getLayers().getArray();
  let addedLayersLabels = olLayers.map((layer) => {
    let name = layer.get('name');
    return name;
  });

  let id = 'oim-list-add-layers-' + map.getTarget();
  var element = document.getElementById(id);
  if (element) {
    element.parentNode.removeChild(element);
  }
  let olAvailableLayers = getAvailablelayers(isGeoServerAvailable, isProd);
  let availableLayersLabels = [];
  Object.entries(olAvailableLayers).forEach((entry) => {
    let [key, layer] = entry;
    if (key != 'graticule') {
      availableLayersLabels.push({ label: dictLayerNames[key].label, server: layer.get('server') });
    }
  });

  let availableLayersLabelsGeoServer = availableLayersLabels.filter((x) => x.server == 'geo').map((x) => x.label);
  let availableLayersLabelsWebServer = availableLayersLabels.filter((x) => x.server == 'web').map((x) => x.label);
  let availableLayersLabelsBaseMaps = availableLayersLabels.filter((x) => x.server == 'baseMaps').map((x) => x.label);

  let list = document.createElement('ul');
  list.id = id;
  list.classList = 'list-group mx-2 mb-3';

  if (availableLayersLabelsGeoServer.length > 0) {
    createLiHeader(`<span>brgis.itu.int</span>`);
    createSubList(availableLayersLabelsGeoServer);
  }

  if (availableLayersLabelsWebServer.length > 0) {
    createLiHeader(`<span>www.itu.int</span>`);
    createSubList(availableLayersLabelsWebServer);
  }

  if (availableLayersLabelsBaseMaps.length > 0) {
    createLiHeader(`<span>Online Basemaps</span>`);
    createSubList(availableLayersLabelsBaseMaps);
  }

  function createLiHeader(innerHTML) {
    let li = document.createElement('li');
    li.classList = 'p-1 ms-1 oim-add-layers-group-header';
    li.innerHTML = innerHTML;
    list.appendChild(li);
  }

  function createSubList(elementsToAdd) {
    for (let i = 0; i < elementsToAdd.length; i++) {
      let name = elementsToAdd[i];

      let btnContainer = document.createElement('div');
      let addedFlag = createFlag('Loaded');

      let btn = createButton({
        classes: 'btn btn-light rounded-pill btn-sm p-1 oim-btn-add-layer',
        clickEvent: {
          method: function (params) {
            let foundLayer = null;
            if (olLayers.length > 0) {
              foundLayer = olLayers.find((layer) => layer.get('name') === name);
            }
            if (!foundLayer) {
              addLayerByName(map, name, addedFlag, isGeoServerAvailable, isProd);
              addedFlag.innerHTML = `Loading...`;
              addedFlag.style.display = 'inline';
              disableElement(btn);
            }
          },
          params: {},
        },
        innerHTML: `<i>${iconsSVG.plus}</i>`,
      });

      if (addedLayersLabels.includes(name)) {
        addedFlag.innerHTML = 'Loaded';
        addedFlag.style.display = 'inline';
        disableElement(btn);
      }
      btnContainer.appendChild(addedFlag);
      btnContainer.appendChild(btn);

      let listItem = document.createElement('li');
      listItem.classList = 'list-group-item d-flex justify-content-between align-items-center py-1';
      let id = `oim-li-add-${name}-` + map.getTarget();
      listItem.id = id;
      listItem.dataset.layer = name;
      let span = document.createElement('span');
      span.innerHTML = `${name}`;
      listItem.appendChild(span);
      listItem.appendChild(btnContainer);
      list.appendChild(listItem);
    }
  }

  return list;
}

function createFlag(text) {
  let flag = document.createElement('span');
  flag.classList = 'me-2 oim-btn-add-flag';
  flag.style.display = 'none';
  flag.innerHTML = text;
  return flag;
}

function getListOrder(mapTarget) {
  let liste = [];
  var ul = document.getElementById('oim-list-layers-' + mapTarget); // Get the ul element by id
  var liElements = ul.querySelectorAll('li'); // Get all li elements within the ul

  liElements.forEach(function (li) {
    var layer = li.dataset.layer; // Get the data-layer attribute
    liste.push(layer);
  });
  return liste;
}

export function createCheckboxes(map, mapContainer, className, checkboxes, leftRight) {
  const container = document.createElement('div');
  container.className = 'oim-checkboxes-parent ' + className;

  let toggleButtonOpen = createButton({
    classes: className + ' btn btn-light p-1 d-none',
    // classes: className + " btn btn-outline-light p-1 d-none",
    id: 'oim-btn-open-' + leftRight,
    clickEvent: {
      method: function (params) {
        container.classList.remove('d-none');
        if (params.event?.classList) {
          params.event.classList.add('d-none');
        }
      },
      params: {},
    },
    innerHTML: ` <i style="color: grey;">${iconsSVG.expand}</i>`,
  });

  let toggleButtonClose = createButton({
    classes: 'btn btn-close position-absolute top-0 end-0 oim-button-size-sm',
    clickEvent: {
      method: function (params) {
        let parentNode = params?.event?.parentNode;
        if (parentNode) {
          parentNode.classList.add('d-none');
          toggleButtonOpen.classList.remove('d-none');
        }
      },
      params: {},
    },
  });

  container.appendChild(toggleButtonClose);

  let lineInserted = 0;
  checkboxes.forEach((checkbox) => {
    let { index, checked, onClick, position, text } = checkbox;

    const element = document.createElement('input');
    element.className = 'oim-checkbox';
    element.type = 'checkbox';
    element.id = `${mapContainer}-chk-${position}-${index}`;

    if (checked) {
      element.checked = true;
    }

    element.addEventListener('click', function (event) {
      onClick(event);
    });

    const label = document.createElement('label');
    label.className = 'oim-checkbox-label';
    label.htmlFor = element.id;

    const span = document.createElement('span');
    span.className = 'oim-checkbox-span';
    span.appendChild(document.createTextNode(text));

    label.appendChild(element);
    label.appendChild(span);
    container.appendChild(label);

    map.addControl(new Control({ element: container }));

    if (lineInserted == 1 && leftRight == 'left' && checkboxes.length > 2) {
      const hr = document.createElement('hr');
      hr.className = 'my-1';
      hr.style.marginRight = '5px';
      container.appendChild(hr);
    }
    lineInserted++;
  });

  map.addControl(new Control({ element: toggleButtonOpen }));
}

export function createDisclaimer(parentContainer) {
  let text =
    'The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of ITU and of the Secretariat of the ITU concerning the legal status of the country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.';

  let classes = {
    container: 'oim-disclaimer-container',
    details: 'oim-disclaimer-details',
    summary: 'oim-disclaimer-summary',
    content: 'oim-disclaimer-content',
  };

  const container = document.createElement('div');
  container.className = classes.container;

  const details = document.createElement('details');
  details.className = classes.details;

  const summary = document.createElement('summary');
  summary.textContent = 'Disclaimer';
  summary.className = classes.summary;

  const content = document.createElement('div');
  content.textContent = text;
  content.className = classes.content;

  details.appendChild(summary);
  details.appendChild(content);
  container.appendChild(details);
  parentContainer.appendChild(container);
}

export function createDisclaimer2(parentContainer) {
  let text = `The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of ITU and of the Secretariat of the ITU concerning the legal status of the country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.`;

  const container = document.createElement('div');
  container.classList = 'oim-disclaimer-container';
  container.style.left = getPositionPixels(parentContainer, 5, 'left');
  container.style.bottom = getPositionPixels(parentContainer, 15, 'bottom');

  const btn = document.createElement('btn');
  btn.classList = 'btn btn-link oim-disclaimer-btn p-1';
  btn.innerHTML = `<span>Disclaimer</span><i class="ms-1">${iconsSVG.info}</i>`;

  addToolTip2({
    element: btn,
    title: `<span>Disclaimer </span><i>${iconsSVG.itu}</i>`,
    content: text,
    position: 'top',
    trigger: 'hover',
  });
  container.appendChild(btn);
  parentContainer.appendChild(container);
}

export function createDivMapInfos(parentContainer) {
  const container = document.createElement('div');
  container.id = 'oim-map-infos-container-' + parentContainer.id;
  container.className = 'oim-map-infos-container';
  parentContainer.appendChild(container);
}

export function applyStyleToMap(mapContainer, chart) {
  const avoidPositions = ['static', 'absolute', '', null, undefined];
  const mapContainerHasStyle = mapContainer.style?.height || mapContainer?.style.width;
  const mapContainerHasClass = mapContainer.className.trim().length > 0 || mapContainer.classList.length > 0;
  const chartHasStyle = chart && (chart.height || chart.width);
  if (mapContainerHasStyle && avoidPositions.includes(mapContainer.style.position?.trim())) {
    mapContainer.style.position = 'relative';
  }

  if (chart) {
    if (chart.class) {
      mapContainer.classList.add(chart.class);
    } else {
      if (chartHasStyle) {
        if (chart.height) {
          mapContainer.style.height = chart.height;
        }
        if (chart.width) {
          mapContainer.style.width = chart.width;
        }
        mapContainer.style.position = 'relative';
      } else {
        if (avoidPositions.includes(chart.position?.trim())) {
          mapContainer.style.position = 'relative';
        }
      }
    }
  } else if (!mapContainerHasStyle && !mapContainerHasClass) {
    mapContainer.classList.add('oim-container');
  }
}

export function getCursorCheckBox(map) {
  let chk = {
    position: 'top-left',
    text: 'Cursor location',
    checked: true,
    onClick: function (event) {
      let container = document.getElementById('oim-coordinates-container-' + map.getTarget());
      if (event.target) {
        let isChecked = event.target.checked;
        if (!isChecked && container) {
          container.style.display = 'none';
        } else {
          container.style.display = 'block';
        }
      }
    },
  };
  return chk;
}
export function getGraticuleCheckBox(map) {
  let chk = {
    position: 'top-left',
    text: 'World Grid',
    checked: true,
    onClick: function (event) {
      toggleLayerVisibilityByName('graticule', map);

      //if (event.target) {
      //    let isChecked = event.target.checked;
      //    if (!isChecked) {
      //        container.style.display = 'none';
      //    }
      //    else {
      //        container.style.display = 'block';
      //    }
      //}
    },
  };
  return chk;
}

export function centerZoomControls(mapTarget) {
  var olZoomElements = mapTarget.querySelectorAll('.ol-zoom');
  let divZoom = null;
  let divRight = mapTarget.querySelector('#oim-manager-container-right-' + mapTarget.id);
  olZoomElements.forEach(function (element) {
    element.classList.add('oim-ol-zoom');
    element.style.setProperty('left', '10px', 'important');
    element.style.setProperty('top', '50%', 'important');
    element.style.setProperty('transform', 'translateY(-50%)', 'important');
    divZoom = element;
  });

  let fullScreen = mapTarget.querySelector('[title="Toggle full-screen"]');

  divZoom.appendChild(fullScreen);

  // fullScreen.forEach(function (element) {
  //   divZoom.appendChild(element);
  // });

  let clearControl = mapTarget.querySelectorAll('.clear-layers');
  clearControl.forEach(function (element) {
    divRight.appendChild(element);
  });
}

function showOnlyCurrentdDialog(divs, btnAction) {
  Object.entries(divs).forEach((entry) => {
    let [key, div] = entry;
    if (key != btnAction) {
      if (div) {
        div.container.classList.remove('show');
        //div.container.style.display = 'none';
      }
    }
  });
  divs[btnAction].container.classList.add('show');
  //divs[btnAction].container.style.display = 'block';
}
function deleteMapPicker(map) {
  let mapcontainer = map?.getTarget();
  if (mapcontainer) {
    let positionPicker = window[mapcontainer]?.positionPicker;
    if (map && positionPicker) {
      map.removeInteraction(positionPicker);
      window[mapcontainer].positionPicker = null;
    }
  }
}

function createBtnManagelayers(divs, map) {
  let btnAction = 'manage';
  let dialog = divs[btnAction];
  let btn = createButton({
    classes: 'btn btn-light float-end mt-1',
    id: 'oim-btn-manage-layers',
    clickEvent: {
      method: function (params) {
        deleteMapPicker(map);
        if (isHidden(dialog)) {
          dialog.divLayers.innerHTML = '';
          let list = createListForManage(map);
          dialog.divLayers.appendChild(list);
          showOnlyCurrentdDialog(divs, btnAction);
        } else {
          //dialog.container.style.display = 'none';
          dialog.container.classList.remove('show');
        }
      },
      params: {},
    },
    innerHTML: `<i>${iconsSVG.layers}</i>`,
  });
  addToolTip(btn, 'Manage layers', 'left');
  return btn;
}

function createBtnAddlayers(divs, map, isGeoServerAvailable, isProd) {
  let btnAction = 'add';
  let dialog = divs[btnAction];
  let btn = createButton({
    classes: 'btn btn-light float-end mt-1',
    id: 'oim-btn-manage-layers-' + map.getTarget(),
    clickEvent: {
      method: function (params) {
        deleteMapPicker(map);
        if (isHidden(dialog)) {
          let list = createListForAdd(map, isGeoServerAvailable, isProd);
          dialog.divLayers.innerHTML = '';
          dialog.divLayers.appendChild(list);
          showOnlyCurrentdDialog(divs, btnAction);
        } else {
          dialog.container.classList.remove('show');
          //dialog.container.style.display = 'none';
        }
      },
      params: {},
    },
    innerHTML: `<i>${iconsSVG.plus}</i>`,
  });
  addToolTip(btn, 'Add layers', 'left');
  return btn;
}

function createBtnClearlayers(divs, map) {
  let confirmModal;
  const clearLayers = () => {
    deleteMapPicker(map);
    map
      .getLayers()
      .getArray()
      .slice()
      .forEach(function (layer) {
        if (layer.get('name') != dictLayerNames['graticule'].label) {
          map.removeLayer(layer);
        }
      });
    divs['manage'].divLayers.innerHTML = '';
    let divAdd = divs['add'].divLayers;
    divAdd.querySelectorAll('.oim-btn-add-flag').forEach((span) => (span.style.display = 'none'));
    divAdd.querySelectorAll('.oim-btn-add-layer').forEach((btn) => enableElement(btn));
    confirmModal?.hide();
  };

  let confirmDialog = createConfirmDialog(clearLayers);

  confirmModal = new Modal(confirmDialog, {
    keyboard: false,
  });
  let btn = document.createElement('button');
  btn.className = 'btn btn-light float-end mt-1';
  btn.innerHTML = `<i>${iconsSVG.trash}</i>`;
  addToolTip(btn, 'Delete all layers', 'left');
  btn.addEventListener(
    'click',
    function () {
      confirmModal.show();
    },
    false
  );
  return btn;
}

function createBtnImportMakers(divs, map) {
  let btnAction = 'importMarkers';
  let dialog = divs[btnAction];

  let btn = createButton({
    classes: 'btn btn-light float-end mt-1',
    id: 'oim-btn-import-markers',
    clickEvent: {
      method: function (params) {
        deleteMapPicker(map);
        if (isHidden(dialog)) {
          const divImport = createDivForImport(map);
          dialog.divLayers.innerHTML = '';
          dialog.divLayers.appendChild(divImport);
          showOnlyCurrentdDialog(divs, btnAction);
        } else {
          dialog.container.classList.remove('show');
          //dialog.container.style.display = 'none';
        }
      },
      params: {},
    },
    innerHTML: `<i>${iconsSVG.importMarkers}</i>`,
  });
  addToolTip(btn, 'Import Markers (.txt)', 'left');
  return btn;
}

function createBtnAddtMarkers(divs, map) {
  let btnAction = 'addMarkers';
  let dialog = divs[btnAction];

  let btn = createButton({
    classes: 'btn btn-light float-end mt-1',
    id: 'oim-btn-add-markers',
    clickEvent: {
      method: function (params) {
        deleteMapPicker(map);
        if (isHidden(dialog)) {
          //const inputFile = createFileInput();
          dialog.divLayers.innerHTML = '';
          let divMarkers = createCoordinatesDiv(map);
          dialog.divLayers.appendChild(divMarkers);

          showOnlyCurrentdDialog(divs, btnAction);
        } else {
          dialog.container.classList.remove('show');
          //dialog.container.style.display = 'none';
        }
      },
      params: {},
    },
    innerHTML: `<i>${iconsSVG.pinAngle}</i>`,
  });
  addToolTip(btn, 'Add Markers', 'left');
  return btn;
}

function isHidden(div) {
  // let result =
  //   !div.container.style.display ||
  //   div.container.style.display == 'none';
  let result = !div.container.classList.contains('show');
  return result;
}

function createButtonBtn(button, divs, map, isGeoServerAvailable, isProd) {
  switch (button) {
    case 'addLayers':
      return createBtnAddlayers(divs, map, isGeoServerAvailable, isProd);
    case 'manageLayers':
      return createBtnManagelayers(divs, map);
    case 'clearLayers':
      return createBtnClearlayers(divs, map);
    case 'importMarkers':
      return createBtnImportMakers(divs, map);
    case 'addMarker':
      return createBtnAddtMarkers(divs, map);
    default:
      return null;
  }
}

export function getPositionPixels(element, value, position) {
  const style = window.getComputedStyle(element);
  const padding = style.getPropertyValue('padding-' + position);
  const result = parseInt(padding, 10);
  return result + value + 'px';
}

export function getHeightPixels(parentContainerId, value) {
  const parentContainer = document.getElementById(parentContainerId);
  const style = window.getComputedStyle(parentContainer);
  const height = style.getPropertyValue('height');
  let result = parseInt(height, 10);
  result = Math.round(result * value, 0) + 'px';
  return result;
}

export function createManageTools(parentContainer, map, isGeoServerAvailable, isProd, buttons) {
  const container = document.createElement('div');
  container.className = 'oim-manage-container btn-group-vertical';
  container.style.position = 'absolute';
  container.style.right = getPositionPixels(parentContainer, 10, 'right');
  container.id = 'oim-manager-container-right-' + map.getTarget();

  const mapping = {
    manageLayers: { dialogName: 'Manage Layers', key: 'manage' },
    addLayers: { dialogName: 'Add Layers', key: 'add' },
    // ClearLayers: { dialogName: 'Add Marker', key: 'addMarkers' },
    importMarkers: { dialogName: 'Import From File (.txt)', key: 'importMarkers' },
    addMarker: { dialogName: 'Add Marker', key: 'addMarkers' },
  };

  if (!buttons) {
    //zero-config --> add the manage button
    buttons = ['manageLayers'];
  }
  let divs = {};

  // let separator = createElement({ elt: 'div', className: ['oim-separator-h'] });
  // container.appendChild(separator);

  buttons.forEach((button) => {
    if (typeof button === 'object') {
      if (button.hasOwnProperty('action')) {
        let innerHTML = `<i>${iconsSVG.play}</i>`;
        if (button.hasOwnProperty('icon')) {
          innerHTML = `<i>${button['icon']}</i>`;
        }
        let btn = createElement({ elt: 'button', className: ['btn', 'btn-success', 'mt-1'], innerHTML: innerHTML });
        btn.addEventListener('click', (event) => {
          const methd = button['action'];
          methd(event, map);
        });
        container.appendChild(btn);
      }
    } else {
      if (mapping[button]) {
        // Create the dialog
        const dialog = createDialog(mapping[button].dialogName, map); //map only needed for Add Marker
        // Add the dialog to the divs object
        divs[mapping[button].key] = dialog;

        let btn = createButtonBtn(button, divs, map, isGeoServerAvailable, isProd);

        //container.appendChild(btnClearlayers);
        container.appendChild(btn);
        container.appendChild(dialog.container);
      }
    }
  });

  parentContainer.appendChild(container);
}

export function createConfirmDialog(confirmEventMethod) {
  const modal = createElement({ elt: 'div', className: ['modal', 'fade'] });
  const modalDialog = createElement({ elt: 'div', className: ['modal-dialog'] });
  const modalContent = createElement({ elt: 'div', className: ['modal-content'] });

  const modalHeader = createElement({ elt: 'div', className: ['modal-header'] });
  modalHeader.appendChild(createElement({ elt: 'h5', className: ['modal-title'], innerHTML: 'Confirmation' }));
  modalHeader.appendChild(
    createElement({
      elt: 'button',
      className: ['btn-close'],
      attributes: { 'data-bs-dismiss': 'modal' },
    })
  );

  const modalBody = createElement({
    elt: 'div',
    className: ['modal-body'],
    innerHTML: 'Are you sure you want to delete all layers?',
  });

  const modalFooter = createElement({ elt: 'div', className: ['modal-footer'] });
  let cancelBtn = createElement({
    elt: 'button',
    className: ['btn', 'btn-secondary'],
    innerHTML: 'Cancel',
    attributes: { 'data-bs-dismiss': 'modal' },
  });
  const confirmBtn = createElement({
    elt: 'button',
    className: ['btn', 'btn-primary'],
    innerHTML: 'Confirm',
  });
  confirmBtn.addEventListener('click', (event) => {
    confirmEventMethod();
  });

  modalFooter.appendChild(cancelBtn);
  modalFooter.appendChild(confirmBtn);

  modalContent.appendChild(modalHeader);
  modalContent.appendChild(modalBody);
  modalContent.appendChild(modalFooter);

  modalDialog.appendChild(modalContent);
  modal.appendChild(modalDialog);

  document.body.appendChild(modal);

  return modal;
}

export function addToolTip(element, content, position) {
  //content = `<span class="oim-tooltip-content">${content}</span>`;
  /* element.setAttribute('data-bs-container', 'body');
  element.setAttribute('data-bs-toggle', 'popover');
  element.setAttribute('data-bs-placement', position);
  element.setAttribute('data-bs-content', content);
  element.setAttribute('data-bs-custom-class', 'oim-tooltip');
  new Popover(element, { trigger: 'hover' }); */

  new Popover(element, {
    //title: 'My Popover Title',
    content: content,
    placement: position,
    container: 'body',
    trigger: 'hover', //'hover', 'click',
    //customClass: 'oim-tooltip',
    html: true,
  });
}

export function addToolTip2({ element, content, position, trigger, title }) {
  //content = `<span class="oim-tooltip-content">${content}</span>`;
  /* element.setAttribute('data-bs-container', 'body');
  element.setAttribute('data-bs-toggle', 'popover');
  element.setAttribute('data-bs-placement', position);
  element.setAttribute('data-bs-content', content);
  element.setAttribute('data-bs-custom-class', 'oim-tooltip');
  new Popover(element, { trigger: 'hover' }); */

  new Popover(element, {
    title: function () {
      var svgContainer = document.createElement('div');
      svgContainer.classList = 'd-flex justify-content-between align-items-center';
      svgContainer.innerHTML = title;
      return svgContainer;
    },
    content: content,
    placement: position,
    container: 'body',
    trigger: trigger, //'hover', 'click',
    customClass: 'oim-tooltip',
    html: true,
  });
}

function createPopover(btn, map) {
  var content = document.createElement('div');
  let slider = createElement({
    elt: 'input',
    className: ['custom-range'],
    attributes: { type: 'range', mim: '0', max: '100' },
  });
  content.appendChild(slider);

  slider.addEventListener('change', function (event) {
    let opacity = Number(event.target.value) / 100;
    let layerName = btn.getAttribute('data-layerName');
    setLayerOpacityyName(layerName, map, opacity);
  });

  let popover = new Popover(btn, {
    content: content,
    container: 'body',
    html: true,
    placement: 'bottom',
    trigger: 'manual',
    title: 'Set the opacity',
  });

  btn.addEventListener('click', function () {
    popover.show();
  });

  document.addEventListener('click', function (event) {
    var isClickInside = event.target == content || content.contains(event.target) || btn.contains(event.target);
    if (!isClickInside) {
      popover.hide();
    }
  });

  // document.addEventListener('click', function (event) {
  //   const isClickInside = event.target.closest('.popover') !== null || event.target === btn;
  //   if (!isClickInside) {
  //     popover.hide();
  //   }
  // });

  return { popover, slider };
}

function createPopoverLegend(btn, legend, li) {
  var content = document.createElement('div');

  let img = document.createElement('img');
  img.classList.add('oim-legend');
  img.src = legend;
  content.appendChild(img);

  let popover = new Popover(btn, {
    content: content,
    container: 'body',
    html: true,
    placement: 'bottom',
    trigger: 'manual',
    template:
      '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body p-1"></div></div>',
  });

  btn.addEventListener('click', function () {
    popover.show();
  });

  document.addEventListener('click', function (event) {
    var isClickInside = event.target == content || content.contains(event.target) || btn.contains(event.target);
    if (!isClickInside) {
      popover.hide();
    }
  });

  btn.addEventListener('shown.bs.popover', function () {
    let popoverNode = document.querySelector('.popover');
    if (popoverNode) {
      const height = li.clientHeight / 2;
      const width = li.clientWidth / 2 - popoverNode.clientWidth / 2;

      // const style = window.getComputedStyle(li);

      const sourceRect = li.getBoundingClientRect();
      const sourceTop = sourceRect.top + height + 'px';
      const sourceLeft = sourceRect.left + width + 'px';

      popoverNode.style.setProperty('position', 'fixed', 'important');
      popoverNode.style.setProperty('top', `${sourceTop}`, 'important');
      popoverNode.style.setProperty('left', `${sourceLeft}`, 'important');
      popoverNode.style.setProperty('transform', `none`, 'important');
    }
  });

  return popover;
}

export function createElement({ elt, className, innerHTML, attributes }) {
  const element = document.createElement(elt);
  if (className && className.length > 0) {
    className.forEach((c) => element.classList.add(c));
  }

  if (innerHTML) {
    element.innerHTML = innerHTML;
  }
  if (attributes) {
    Object.entries(attributes).forEach(([key, value]) => {
      if (key == 'checked') {
        element.checked = value;
      } else {
        element.setAttribute(key, value);
      }
    });
  }
  return element;
}

export function disableElement(element) {
  element.setAttribute('disabled', 'disabled');
  element.style.opacity = 0.2;
}
function enableElement(element) {
  element.style.opacity = 1;
  element.disabled = false;
}

function createCoordinatesRadioDiv() {
  let container = createElement({ elt: 'div', className: ['p-2', 'oim-w98'] });
  let row1 = createElement({ elt: 'div', className: ['row', 'ms-1'] });
  let col1 = createElement({ elt: 'div', className: ['col-sm-12'] });
  let coordDD = createRadio('DD', true, 'radioCoord');
  let coordDMS = createRadio('DMS', false, 'radioCoord');

  col1.appendChild(coordDD);
  col1.appendChild(coordDMS);
  row1.appendChild(col1);
  container.appendChild(row1);
  return container;
}

function createCoordinatesDiv(map) {
  const layerName = 'markers';
  let mapContainer = map.getTarget();

  let container = createElement({ elt: 'div', className: ['p-2', 'oim-w98'] });
  let row1 = createElement({ elt: 'div', className: ['row', 'ms-1'] });
  let col1 = createElement({ elt: 'div', className: ['col-sm-12'] });

  let groupDD = createDivCoordinatesDD();
  let groupDMS = createDivCoordinatesDMS();

  let positionPicker = createMarkerPickerTool(map, groupDD, groupDMS);
  window[mapContainer].positionPicker = positionPicker;

  let label = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'mt-2'],
    attributes: { placeholder: 'Label', value: 'Point ' },
  });

  let ckkContainer = createElement({
    elt: 'div',
    className: ['d-flex', 'justify-content-start', 'align-items-baseline'],
  });
  let select = createSelect(['DD', 'DMS']);
  let chkFromMap = createCheck('Select from map', false, 'oim-chk-coord-from-map-' + mapContainer);
  chkFromMap.input.addEventListener('click', (event) => {
    positionPicker.setActive(event.target.checked);
  });

  select.addEventListener('change', (event) => {
    if (select.value == 'DD') {
      groupDD.container.style.display = 'block';
      groupDMS.container.style.display = 'none';
    } else {
      groupDD.container.style.display = 'none';
      groupDMS.container.style.display = 'block';
    }
  });

  let btnAdd = createButton({
    classes: 'btn btn-sm btn-secondary float-end mt-3',
    id: 'oim-btn-add-marker',
    clickEvent: {
      method: function (params) {
        let point, valLong, valLat;
        if (select.value == 'DD') {
          valLong = parseFloat(groupDD.long.value);
          valLat = parseFloat(groupDD.lat.value);
        } else {
          valLong = getValueLong(groupDMS.long);
          valLat = getValueLat(groupDMS.lat);
        }

        point = {
          long: valLong,
          lat: valLat,
          label: label.value,
        };

        if (isNaN(point.long) || isNaN(point.lat)) {
          alert('Error in Coordinates');
          return;
        }
        addLayerPoint({ point, layerName, map, isForMarkers: true, hasDeleteBtn: true, hasLabels: true });
      },
      params: {},
    },
    innerHTML: `Add to map`,
  });

  ckkContainer.appendChild(select);
  ckkContainer.appendChild(chkFromMap.container);

  col1.appendChild(ckkContainer);
  col1.appendChild(groupDD.container);
  col1.appendChild(groupDMS.container);
  col1.appendChild(label);
  col1.appendChild(btnAdd);

  row1.appendChild(col1);
  container.appendChild(row1);
  return container;
}

function getValueLong(longElement) {
  let result =
    Number(longElement.longD.value) + Number(longElement.longM.value) / 60 + Number(longElement.longS.value) / 3600;
  if (longElement.select.value == 'W') {
    result = -result;
  }
  return result;
}
function getValueLat(latElement) {
  let result =
    Number(latElement.latD.value) + Number(latElement.latM.value) / 60 + Number(latElement.latS.value) / 3600;
  if (latElement.select.value == 'S') {
    result = -result;
  }
  return result;
}

function createDivCoordinatesDD() {
  let container = createElement({ elt: 'div' });
  let longLabel = createElement({
    elt: 'label',
    className: ['col-form-label', 'mt-2', 'ms-1'],
    innerHTML: 'Longitude(DD)',
  });
  let long = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm'],
    //attributes: { placeholder: 'Longitude' },
  });
  let latLabel = createElement({
    elt: 'label',
    className: ['col-form-label', 'mt-2', 'ms-1'],
    innerHTML: 'Latitude(DD)',
  });
  let lat = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm'],
    //attributes: { placeholder: 'Latitude' },
  });

  container.appendChild(longLabel);
  container.appendChild(long);
  container.appendChild(latLabel);
  container.appendChild(lat);

  return {
    container,
    long,
    lat,
  };
}

function createDivCoordinatesDMS() {
  let container = createElement({ elt: 'div' });
  container.style.display = 'none';
  let long = createDivGroupDMSLongitude();
  let longLabel = createElement({
    elt: 'label',
    className: ['col-form-label', 'ms-1', 'mt-2'],
    innerHTML: 'Longitude(DMS)',
  });
  let lat = createDivGroupDMSLatitude();
  let latLabel = createElement({
    elt: 'label',
    className: ['col-form-label', 'ms-1', 'mt-2'],
    innerHTML: 'Latitude(DMS)',
  });

  container.appendChild(longLabel);
  container.appendChild(long.container);
  container.appendChild(latLabel);
  container.appendChild(lat.container);
  return {
    container,
    long,
    lat,
  };
}

function createDivGroupDMSLongitude() {
  let container = createElement({ elt: 'div', className: ['input-group'] });
  let select = createSelect(['E', 'W']);
  let longD = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'D', type: 'number', min: '0', max: '179' },
  });
  let longM = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'M', type: 'number', min: '0', max: '59' },
  });
  let longS = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'S', type: 'number', min: '0', max: '59' },
  });
  container.appendChild(longD);
  container.appendChild(longM);
  container.appendChild(longS);
  container.appendChild(select);
  return {
    container,
    longD,
    longM,
    longS,
    select,
  };
}

function createDivGroupDMSLatitude() {
  let container = createElement({ elt: 'div', className: ['input-group'] });
  let select = createSelect(['N', 'S']);
  let latD = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'D', type: 'number', min: '0', max: '89' },
  });
  let latM = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'M', type: 'number', min: '0', max: '59' },
  });
  let latS = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'px-1', 'text-center'],
    attributes: { placeholder: 'S', type: 'number', min: '0', max: '59' },
  });
  container.appendChild(latD);
  container.appendChild(latM);
  container.appendChild(latS);
  container.appendChild(select);
  return {
    container,
    latD,
    latM,
    latS,
    select,
  };
}

function createSelect(options, className) {
  let select = createElement({
    elt: 'select',
    className: ['form-select', 'form-select-sm', 'oim-w-fit-content'],
  });
  if (className) {
    className.forEach((c) => select.classList.add(c));
  }
  select.style.width = 'fit-content !important';
  options.forEach((option) => {
    let optionElement = createElement({ elt: 'option', innerHTML: option });
    select.appendChild(optionElement);
  });
  return select;
}

function createRadio(label, ischecked, name) {
  let divParent = createElement({
    elt: 'div',
    className: ['form-check', 'form-check-inline'],
  });
  let input = createElement({
    elt: 'input',
    className: ['form-check-input'],
    attributes: { id: name + label, type: 'radio', checked: ischecked, name: name },
  });
  let labelElement = createElement({
    elt: 'label',
    className: ['form-check-label'],
    innerHTML: label,
  });
  labelElement.setAttribute('for', input.id);
  divParent.appendChild(input);
  divParent.appendChild(labelElement);
  return divParent;
}

function createCheck(label, ischecked, id) {
  let container = createElement({
    elt: 'div',
    className: ['form-check', 'form-check-inline', 'ms-1'],
  });
  let input = createElement({
    elt: 'input',
    className: ['form-check-input'],
    attributes: { id: id, type: 'checkbox', checked: ischecked },
  });
  let labelElement = createElement({
    elt: 'label',
    className: ['form-check-label'],
    innerHTML: label,
  });
  labelElement.style.fontSize = '12px';
  labelElement.setAttribute('for', input.id);
  container.appendChild(input);
  container.appendChild(labelElement);
  return {
    container,
    input,
  };
}

function createDivForImport(map) {
  let container = createElement({ elt: 'div', className: ['p-2', 'oim-w98'] });
  let row1 = createElement({ elt: 'div', className: ['row', 'ms-1'] });
  let col1 = createElement({ elt: 'div', className: ['col-sm-12'] });

  let ckkContainer = createElement({
    elt: 'div',
    className: ['d-flex', 'justify-content-start', 'align-items-baseline'],
  });
  let selectUnitCoord = createSelect(['DD']);
  addToolTip(selectUnitCoord, 'Coordinates Unit', 'top');
  let selectDelimiter = createSelect(['Space', 'Semicolon', 'Comma', 'Tab'], ['ms-1']);
  addToolTip(selectDelimiter, 'Delimiter', 'top');
  let chkFirstLine = createCheck('Has Header', true, 'oim-chk-first-line-header');
  chkFirstLine.input.addEventListener('click', (event) => {});

  selectUnitCoord.addEventListener('change', (event) => {
    if (selectUnitCoord.value == 'DD') {
    } else {
    }
  });
  const file = { name: '', content: '' };
  let points = [];

  const tableMarkers = createTable();

  let containerInputFile = createElement({
    elt: 'div',
    className: ['d-flex', 'justify-content-start', 'align-items-baseline', 'mt-2'],
  });

  let fileNameElement = createElement({
    elt: 'label',
    className: ['form-label', 'ms-2'],
    innerHTML: 'No file selected',
  });

  const inputFile = createInputfile(
    '...',
    'oim-markers-input-import',
    'Select file (.txt)</br><span class="oim-tooltip-format">(Longitude, Latitude, Label)</span>',
    file,
    fileNameElement
  );

  let btnLoad = createButton({
    classes: 'btn btn-sm btn-secondary ms-2',
    clickEvent: {
      method: function (params) {
        points = fillTable(tableMarkers.table, file.content, chkFirstLine.input.checked, selectDelimiter.value);
      },
      params: {},
    },
    innerHTML: `Load`,
  });

  let btnAdd = createButton({
    classes: 'btn btn-sm btn-secondary float-end mt-3',
    id: 'oim-btn-add-marker',
    clickEvent: {
      method: function (params) {
        let pts = points.filter((pt) => pt.long != 'Error' && pt.lat != 'Error');
        const layerName = removeExtension(fileNameElement?.innerText);
        addLayerPoints({ points: pts, layerName, map, isForMarkers: true, hasLabels: true });
      },
      params: {},
    },
    innerHTML: `Add to map`,
  });

  ckkContainer.appendChild(selectUnitCoord);
  ckkContainer.appendChild(selectDelimiter);
  ckkContainer.appendChild(chkFirstLine.container);
  col1.appendChild(ckkContainer);
  containerInputFile.appendChild(inputFile);
  containerInputFile.appendChild(btnLoad);
  containerInputFile.appendChild(fileNameElement);
  col1.appendChild(containerInputFile);
  col1.appendChild(tableMarkers.container);
  col1.appendChild(btnAdd);

  row1.appendChild(col1);
  container.appendChild(row1);
  return container;
}

export function createFileInput() {
  const input = document.createElement('input');
  input.type = 'file';

  return input;
}

function createInputfile(label, id, tooltip, file, fileNameElement) {
  let container = createElement({
    elt: 'div',
    className: ['d-flex', 'justify-content-start', 'align-items-baseline', 'mt-2'],
  });
  let input = createElement({
    elt: 'input',
    className: ['form-control', 'form-control-sm', 'form-control-file'],
    attributes: { id: id, type: 'file', attributes: { accept: '.txt' } },
  });
  input.style.display = 'none';

  input.addEventListener('change', async function (event) {
    let selectedFile = event.target.files[0];
    file.name = selectedFile.name;
    fileNameElement.innerText = file.name;
    if (selectedFile) {
      file.content = await readFileAsText(selectedFile);
    } else {
      file.content = '';
    }
  });

  let labelElement = createElement({
    elt: 'label',
    className: ['btn', 'btn-sm', 'btn-secondary'],
    innerHTML: label,
  });
  labelElement.setAttribute('for', input.id);
  if (tooltip) {
    addToolTip(labelElement, tooltip, 'top');
  }

  container.appendChild(input);
  container.appendChild(labelElement);

  return container;
}

function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
}

function createTable() {
  let container = createElement({
    elt: 'div',
    className: ['mt-3', 'oim-table-markers'],
  });
  let table = document.createElement('table');
  table.classList = 'table table-sm display compact table-bordered collapse-table oim-table-markers';
  table.style.fontSize = '11px';
  table.id = 'oim-table-markers';
  let thead = document.createElement('thead');
  thead.classList = 'table-light';
  let headerRow = document.createElement('tr');

  let headers = ['Longitude', 'Latitude', 'Label'];
  for (var i = 0; i < headers.length; i++) {
    var th = document.createElement('th');
    th.textContent = headers[i];
    headerRow.appendChild(th);
  }

  thead.appendChild(headerRow);
  table.appendChild(thead);
  let tbody = document.createElement('tbody');
  tbody.id = 'oim-table-markers-body';
  table.appendChild(tbody);

  container.appendChild(table);
  return { container, table };
}

function parseFile(content, hasHeader, delimiter) {
  const lines = content.split(/\r?\n/)?.filter(Boolean);

  if (hasHeader) {
    lines.shift();
  }
  let points = [];

  lines.forEach((line) => {
    line = line?.trim();
    if (line) {
      const columns = line.split(delimiter);
      const noColumns = columns.length;

      let selectedColumns = columns.slice(2, noColumns); // Gets elements from index 2 to the last
      let result = selectedColumns.join(' '); // Concatenates the elements with a

      let point = {
        long: Number(columns[0]),
        lat: Number(columns[1]),
        label: result,
      };
      if (isNaN(point.long)) {
        point.long = 'Error';
      }
      if (isNaN(point.lat)) {
        point.lat = 'Error';
      }
      points.push(point);
    }
  });

  return points;
}

function fillTable(table, content, hasHeader, delimiter) {
  let delimiters = {
    Tab: '\t',
    Semicolon: ';',
    Comma: ',',
    Space: ' ',
  };
  let points = parseFile(content, hasHeader, delimiters[delimiter]);

  let tbody = table.tBodies[0];

  tbody.innerHTML = '';

  for (var i = 0; i < points.length; i++) {
    let row = document.createElement('tr');
    let pt = points[i];

    let cellLabel = createElement({ elt: 'td', innerHTML: pt.label });
    let cellLong = createElement({ elt: 'td', innerHTML: pt.long });
    let cellLat = createElement({ elt: 'td', innerHTML: pt.lat });
    if (pt.long == 'Error') {
      cellLong.style.color = 'red';
    }
    if (pt.lat == 'Error') {
      cellLat.style.color = 'red';
    }

    row.appendChild(cellLong);
    row.appendChild(cellLat);
    row.appendChild(cellLabel);

    tbody.appendChild(row);
  }
  return points;
}

export function parseHtmlStringForIDWMgroup(data) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(data, 'text/html');
  if (doc) {
    //let tables = doc.getElementsByTagName('table');
    let tables = doc.querySelectorAll('table.featureInfo');

    if (tables.length > 1) {
      var secondTable = tables[1];

      var trs = secondTable.querySelectorAll('table tr');
      if (trs.length > 1) {
        let ths = parseElement(trs[0].querySelectorAll('th'));
        let tds = parseElement(trs[1].querySelectorAll('td'));
        return {
          ths,
          tds,
        };
      }
    }
  }
  return {
    ths: [],
    tds: [],
  };
}

export function parseHtmlString(data) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(data, 'text/html');
  if (doc) {
    var trs = doc.querySelectorAll('table tr');
    if (trs.length > 1) {
      let ths = parseElement(trs[0].querySelectorAll('th'));
      let tds = parseElement(trs[1].querySelectorAll('td'));
      return {
        ths,
        tds,
      };
    }
  }
  return {
    ths: [],
    tds: [],
  };
}

function parseElement(elements) {
  let result = Array.from(elements).map((elt) => elt.textContent);
  return result;
}

export function createSpinner() {
  //   let spinner = `<button class="btn btn-primary" type="button" disabled>
  //   <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
  //   Loading...
  // </button>`;
  let spinner = `<button class="btn btn-primary" type="button" disabled>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Loading...
    </button>`;
  let div = createElement({ elt: 'div', innerHTML: spinner, className: ['oim-loader-wrapper'] });
  return div;
}
export function createSpinner2() {
  let div = createElement({
    elt: 'div',
    innerHTML: '<span class="sr-only"></span>',
    className: ['spinner-border', 'text-primary'],
    attributes: { role: 'status' },
  });
  return div;
}

function makeListDraggable(listElements, map) {
  var classMove = 'oim-list-grab-move';

  // Variables to store the currently dragged element and its position
  var draggedElem, draggedElemPos;

  listElements.addEventListener('dragstart', function (event) {
    // Store the current element and its position
    draggedElem = event.target;
    draggedElemPos = Array.from(listElements.children).indexOf(draggedElem);
    draggedElem.classList.add(classMove);
  });

  listElements.addEventListener('dragover', function (event) {
    // Prevent default to allow drop
    event.preventDefault();

    let currentElem = event.target.closest('li');

    if (currentElem) {
      let currentElemPos = Array.from(listElements.children).indexOf(currentElem);

      // Swap the elements if necessary
      if (currentElemPos !== draggedElemPos) {
        let temp = document.createElement('li');
        listElements.insertBefore(temp, listElements.children[draggedElemPos]);
        listElements.insertBefore(draggedElem, listElements.children[currentElemPos]);
        listElements.insertBefore(currentElem, temp);
        listElements.removeChild(temp);
        draggedElemPos = currentElemPos;
      }
    }
  });

  listElements.addEventListener('dragend', function (event) {
    if (draggedElem) {
      setTimeout(function () {
        if (draggedElem.classList && draggedElem.classList.length > 0) {
          draggedElem.classList.remove(classMove);
          draggedElem = null;
          draggedElemPos = null;
          var order = getListOrder(map.getTarget()); // Get the order
          setZIndexs(map, order);
        }
      }, 100);
    }
  });
}

export function createMapTooltip(container, map) {
  let tooltip = createElement({
    elt: 'div',
    className: ['ol-tooltip', 'oim-ol-tooltip'],
    attributes: { id: `${container.id}-tooltip` },
  });
  let tooltipContent = createElement({
    elt: 'div',
    className: [],
    attributes: { id: `${container.id}-tooltip-content` },
  });
  tooltip.appendChild(tooltipContent);
  map.tooltip = tooltip;
  map.tooltipContent = tooltipContent;
  container.appendChild(tooltip);
}

export function createMapPopup(id) {
  let container = createElement({
    elt: 'div',
    className: ['oim-popup-left'],
    attributes: { id: `popup-${id}` },
  });
  let content = createElement({
    elt: 'div',
    className: ['oim-popup-left-content'],
    attributes: { id: `popup-content-${id}` },
  });
  let decoration = createElement({
    elt: 'div',
    className: ['oim-popup-left-decoration'],
    attributes: { id: `popup-decoration-${id}` },
  });
  let title = createElement({
    elt: 'span',
    className: ['oim-popup-left-title', 'ms-3'],
    attributes: { id: `popup-title-${id}` },
  });
  let closer = createElement({
    elt: 'a',
    className: ['oim-popup-closer'],
    attributes: { id: `popup-closer-${id}`, href: `/` },
  });

  decoration.appendChild(title);
  decoration.appendChild(closer);

  container.appendChild(decoration);
  container.appendChild(content);

  let popup = {
    container: container,
    content: content,
    title: title,
    closer: closer,
  };
  return popup;
}

export function createDropDownMenu(btns, lastBtn) {
  const container = document.createElement('div');
  container.classList.add('btn-group');

  // Create the button element with btn and btn-secondary classes
  const button = document.createElement('button');
  button.classList.add('btn', 'dropdown-toggle', 'py-1');
  button.setAttribute('type', 'button');
  button.setAttribute('data-bs-toggle', 'dropdown');
  button.setAttribute('aria-expanded', 'false');

  if (btns.length == 0) {
    button.style.visibility = 'hidden';
  }

  let fakeClass = 'oim-dropdown-menu-fake';

  // Create the ul element with the dropdown-menu class
  const ul = document.createElement('ul');
  button.addEventListener('click', function (event) {
    let els = document.querySelectorAll('.' + fakeClass);
    els.forEach((elt) => {
      if (elt.classList.contains('show')) {
        if (window.getComputedStyle(elt).display !== 'block') {
          elt.style.display = 'block';
        } else {
          elt.style.display = '';
        }
      }
    });
  });

  ul.classList.add('dropdown-menu');
  ul.classList.add('px-2');
  ul.classList.add('py-1');
  ul.classList.add(fakeClass);
  ul.style.setProperty('min-width', 'fit-content', 'important');
  const li = document.createElement('li');
  const div = document.createElement('div');
  div.classList.add('btn-group');
  li.appendChild(div);

  btns.forEach((elt) => {
    elt.btn.classList.add('dropdown-item');
    if (elt.disabled) {
      elt.btn.classList.add('disabled');
    }
    div.appendChild(elt.btn);
  });

  ul.appendChild(li);

  // Create the last dropdown item
  if (lastBtn) {
    const hr = document.createElement('hr');
    hr.classList.add('dropdown-divider');
    ul.appendChild(hr);

    const lastLi = document.createElement('li');
    lastBtn.btn.classList.add('dropdown-item');
    if (lastBtn.disabled) {
      lastBtn.btn.classList.add('disabled');
    }
    lastLi.appendChild(lastBtn.btn);
    ul.appendChild(lastLi);
  }

  container.appendChild(button);
  if (btns.length > 0) {
    container.appendChild(ul);
  }

  return container;
}
export function createMapControls(container, params, isGeoServerAvailable, map) {
  let { checkboxes, isProd, buttons } = params || {};

  createDisclaimer2(container);
  createDivMapInfos(container);

  if (checkboxes) {
    checkboxes.unshift(getGraticuleCheckBox(map));
    checkboxes.unshift(getCursorCheckBox(map));
  } else {
    checkboxes = [getGraticuleCheckBox(map), getCursorCheckBox(map)];
  }

  createChkIndexes(checkboxes);
  let chkTopRight = checkboxes.filter((x) => x.position == 'top-right');
  let chkTopLeft = checkboxes.filter((x) => x.position == 'top-left');

  createCheckboxes(map, container.id, 'oim-checkboxes-top-left-container', chkTopLeft, 'left');

  if (chkTopRight.length > 0) {
    createCheckboxes(map, container.id, 'oim-checkboxes-top-right-container', chkTopRight, 'right');
  }

  createManageTools(container, map, isGeoServerAvailable, isProd, buttons);

  createMapTooltip(container, map);

  centerZoomControls(container);
}
